import type {
  ICreateSavedFilterRequestBody,
  ICreateSavedFilterResponseBody,
  IDeleteSavedFilterRequestParams,
  IGetSavedFiltersRequestParams,
  IGetSavedFiltersResponseBody,
  IUpdateSavedFilterRequestData,
  IUpdateSavedFilterResponseBody,
} from "~/feature/savedFilters/types";
import { api, ApiTagType } from "~/store/api";

const API_PREFIX = "/saved-filters";

const savedFiltersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getSavedFilters: builder.query<
      IGetSavedFiltersResponseBody,
      IGetSavedFiltersRequestParams
    >({
      query: (params) => ({
        url: API_PREFIX,
        params,
      }),
      providesTags: [ApiTagType.SavedFilters],
    }),
    createSavedFilter: builder.mutation<
      ICreateSavedFilterResponseBody,
      ICreateSavedFilterRequestBody
    >({
      query: (body) => ({
        url: API_PREFIX,
        body,
        method: "POST",
      }),
      invalidatesTags: [ApiTagType.SavedFilters],
    }),
    updateSavedFilter: builder.mutation<
      IUpdateSavedFilterResponseBody,
      IUpdateSavedFilterRequestData
    >({
      query: ({ slug, body }) => ({
        url: `${API_PREFIX}/${slug}`,
        body,
        method: "PATCH",
      }),
      invalidatesTags: [ApiTagType.SavedFilters],
    }),
    deleteSavedFilter: builder.mutation<void, IDeleteSavedFilterRequestParams>({
      query: ({ slug }) => ({
        url: `${API_PREFIX}/${slug}`,
        method: "DELETE",
      }),
      invalidatesTags: [ApiTagType.SavedFilters],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSavedFiltersQuery,
  useCreateSavedFilterMutation,
  useUpdateSavedFilterMutation,
  useDeleteSavedFilterMutation,
} = savedFiltersApi;
